module.exports = __webpack_public_path__ + "static/Freshworks-62500ef691b8659769f8a60cea23d318.jpg";